'use strict';

var callBind = require('../../../../../_virtual/callBind.js_commonjs-module.js');
var index = require('../../../../function-bind/index.js');
var GetIntrinsic$1 = require('../GetIntrinsic.js');

var bind = index;

var GetIntrinsic = GetIntrinsic$1;

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

callBind.callBind.exports = function callBind() {
	return bind.apply($call, arguments);
};

callBind.callBind.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};
